<template>
  <div class="container my-5">
    <c-infinite-scroll
      as="ul"
      class="client-timeline"
      scroll-target="#page-content-wrapper"
      @load="loadNextPage"
    >
      <client-timeline-item v-for="item in items" :key="item.key" :event="item" />

      <template v-slot:empty>
        <li class="client-timeline-empty">
          <p class="text-center text-muted">No activity for this client yet.</p>
        </li>
      </template>
    </c-infinite-scroll>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ClientTimelineItem from './ClientTimelineItem'

export default {
  components: {
    ClientTimelineItem
  },

  computed: {
    ...mapState('clients', ['timeline']),

    // Timeline events come from several tables so ids aren't unique on their own
    items () {
      return this.timeline.map(event => ({ ...event, key: `${event.type}-${event.id}-${event.when}` }))
    }
  },

  created () {
    this.request = this.getClientTimeline({ id: this.$route.params.client_id, payload: {} })
  },

  methods: {
    ...mapActions('clients', ['getClientTimeline', 'appendClientTimeline']),

    async loadNextPage (done) {
      try {
        await this.request
        await this.appendClientTimeline({ id: this.$route.params.client_id, payload: {} })

        done()
      } catch (error) {
        done(true)
      }
    }
  }
}
</script>

<style scoped>
.client-timeline {
  --timeline-line-color: #dee2e6;
  --timeline-icon-size: 2.5rem;

  position: relative;
  list-style: none;
  margin: 0;
  padding: 0;
}

/* Vertical line, on the left on mobile and centred on desktop */
.client-timeline::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: calc(var(--timeline-icon-size) / 2);
  width: 2px;
  margin-left: -1px;
  background: var(--timeline-line-color);
}

.client-timeline > li {
  position: relative;
}

.client-timeline-empty::before {
  display: none;
}

@media (min-width: 992px) {
  .client-timeline::before {
    left: 50%;
  }
}
</style>
